import { useEffect, useRef } from "react";

import styles from "./statisticsPage.module.css";
import AppBar from "../../components/appBar/appBar";
import ImgBuilder from "../../assets/ImgBuilder";
import AbortGame from "../../components/abortGame/abortGame";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BarText, DonutText, Timer, Box} from '../../components/statisticsComponents';
import { getStatistics } from "../../api/api";
import { useUserData } from '../../functions/updateUserData';


const StatisticsPage = () => {
  const navigate = useNavigate();
  const { userData, setUserData } = useUserData();
  const { t } = useTranslation();
  const loading = useRef(false);

  useEffect(() => {
    if (loading.current) return; // loading is true, no need for additional calls
    
    const fetchTopics = async () => {
      loading.current = true;
      try {
        const statistics = await getStatistics(userData.tokens["access_token"], userData.headlineData.trace_id);
        setUserData(prev => ({
          ...prev,
          statistics: statistics
        }));  
      } catch (error) {
        console.error("Failed to fetch statistics about the user:", error);
      } finally{
        loading.current = false;
      }
    };

    fetchTopics();

  }, [userData.tokens, userData.headlineData, setUserData]);


  const handleClick = () => {
    navigate("/profile")
  };

  return (
    <div className={styles.wrapper}>
      <img alt="bg" className={styles.bgImg} src={ImgBuilder.sbBackground}/>
      <AppBar />
      <AbortGame />
      <div className={styles.container}>
        <p className={styles.pageName}>{t("statistics.title")}</p>
        
        {userData.statistics && 
        <div className={styles.statisticsBox}>
          <p className={styles.statisticsTitle}>
            {t("statistics.subtitle")}
          </p>

          <div className={styles.statisticsBoxContainer}>

            <Box text={t("statistics.trust")}>
              <DonutText percentage={Math.round(userData.statistics.trust_rate*100)}/>
              <div className={styles.crowdText}>{t("statistics.trust_quote")}</div>
            </Box>


            <Box text={t("statistics.speed")}>
              <Timer time={Math.round(userData.statistics.reaction_time.reaction_time)}/>
              <BarText percentage={Math.round(userData.statistics.reaction_time.faster*100)} text={t("statistics.speed_diff", { returnObjects: true })}/>
            </Box>


            


            


            {/* IFF it is given */}
            {userData.statistics.flip_rate &&
            <Box text={t("statistics.changes")}>
              {/* <DonutText percentage={userData.statistics.flip_rate.additionalProp1} text={t("statistics.changes_1donut")}/>
              <DonutText percentage={userData.statistics.flip_rate.additionalProp2} text={t("statistics.changes_2donut")}/> */}
              <div className={styles.itemContent}>
                <div className={`${styles.outer} ${styles.outerAlone}`}>
                  <b className={styles.percentageCrowd}>{(userData.statistics.flip_rate.total*100)}%</b> {t("statistics.changes_times")}<br/>
                </div>
                <div className={styles.additionalTextDonut}>{t("statistics.changes_times_explanation")}</div>
              </div>
            </Box>
            }

            <Box text={t("statistics.correctness")}>
              <BarText percentage={Math.round(userData.statistics.tp_fp_rate.reliable_true*100)} text={t("statistics.correctness_1bar", { returnObjects: true })}/>
              <BarText percentage={Math.round(userData.statistics.tp_fp_rate.shady_fake*100)} text={t("statistics.correctness_2bar", { returnObjects: true })}/>


              <div className={styles.crowdText}>
                {t("statistics.correctness_diff", { returnObjects: true })[0]}{" "} 
                <b className={styles.percentageCrowd}> 
                 {Math.round(((userData.statistics.tp_fp_rate.reliable_true*userData.statistics.trust_rate)
                  + ((1-userData.statistics.tp_fp_rate.shady_fake)*(1-userData.statistics.trust_rate)))*100)}%
                </b>{" "} 
                {t("statistics.correctness_diff", { returnObjects: true })[1]}
              </div>
            </Box>

            {userData.statistics.crowd_alignment &&
            <Box text={t("statistics.crowd")} vertical={true}>
              <div className={styles.itemContent}>
                <div className={styles.outer}>
                  <img src={ImgBuilder.crowd} alt={"icon_crowd"} className={styles.crowdPhoto}/>
                </div>
                <div className={styles.additionalTextDonut}>
                  {t("statistics.crowd_diff", { returnObjects: true })[0]} <b className={styles.percentageCrowd}>{Math.round(userData.statistics.crowd_alignment.average*100)}%</b> {t("statistics.crowd_diff", { returnObjects: true })[1]}
                </div>
              </div>
              <DonutText percentage={Math.round(userData.statistics.crowd_alignment.reliable*100)} text={t("statistics.crowd_1donut")}/>
              <DonutText percentage={Math.round(userData.statistics.crowd_alignment.shady*100)} text={t("statistics.crowd_2donut")}/>
            </Box>
            } 


          </div>

        </div>
        }

      </div>
        

      <div className={styles.buttonsContainer}>
        <button onClick={() => handleClick()}  className={styles.button}>{t("statistics.button")}</button>
      </div>

    </div>
  );
};

export default StatisticsPage;
